import React, { useState } from 'react';
import Logo from '../Image/logo.png';
import PHONE from '../Image/phone.png';
import FACEBOOK from '../Image/facebook.png';
import GMAIL from '../Image/gmail.png';
import LINKDIN from '../Image/linkdine.png';
import INSTA from '../Image/insta.png';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { useLocation, Link } from 'react-router-dom';
import { AbonnemetRequest } from '../Api/Abonner';
import { toast } from 'react-toastify';
import '../Css/footer.css';
const Footer = () => {

    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    let location = useLocation();

    const handleEnvoyer = (e) => {
        e.preventDefault();
        setLoading(true);
        const data = { email: email };
        AbonnemetRequest(data).then(function (response) {
            console.log(response);
            if (response.data.title === "success") {
                toast.success(response.data.message);
            }
        }).catch(function (error) {
            console.log(error);
            if (error) {
                toast.error(error.response.data?.message);
            }

        }).finally(function () {
            setLoading(false);
            setEmail('');
        });
    }
    return (
        <>
            {location.pathname !== '/contact' ?
                <section className='footer_Contact'>

                    <div className='d-flex justify-content-between'>
                        <div className='text mt-2'>
                            <h4>Avez-vous des questions ?</h4>
                            <p>Nous vous aiderons à trouver les meilleur restaurants.</p>
                        </div>
                        <Link to="/contact" title='contact'><button className='btn_contact'>Contactez-nous aujourd'hui</button></Link>
                    </div>
                </section> : ''
            }
            <footer>
                <div className='footer_bloc'>
                    <div className='row justify-content-between'>
                        <div className='col-12 col-sm-6 col-md-5 col-lg-5 col-xl-5'>
                            <div className='box'>
                                <div className='logo'>
                                    <div className='d-flex justify-content-center'>
                                        <img src={Logo} alt="Logo Ikaly" />
                                    </div>
                                    <h2 className='text-center mt-3'>Avez-vous besoin d'aide pour quoi que ce soit ?</h2>
                                    <p>Recevez chaque mois des mises à jour, des offres spéciales, des nouvaux restaurants et des remises directement dans votre boîte de réception</p>

                                    <form onSubmit={handleEnvoyer}>
                                        <div className='input d-flex'>
                                            <input type='email' value={email} onChange={(e) => setEmail(e.target.value)} required className='form-control' placeholder='Adresse email ...' />
                                            {loading ? <Button className='btn btn_confirmFooter' disabled>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                    variant="info"
                                                    className="spiner"
                                                />
                                                Chargement...
                                            </Button> : <button type='submit' className='button_subscriber'>S'abonner</button>}

                                        </div>
                                    </form>
                                </div>
                            </div>

                        </div>
                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                            <div className='row'>
                                <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4'>
                                    <div className='titre_element'>
                                        <h3>Pages</h3>
                                    </div>
                                    <hr />
                                    <div className='element'>
                                        <div>  <span>Accueil</span></div>
                                        <div>  <span>Comment ça marche</span></div>
                                        <div>  <span>S'inscrire</span></div>
                                        <div>  <span>Se connecter</span></div>
                                        <div>  <span>Contact</span></div>
                                        <div>  <span>Accès Restaurateur</span></div>
                                    </div>
                                </div>
                                <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4'>
                                    <div className='titre_element'>
                                        <h3>Type de cuisines</h3>

                                    </div>
                                    <hr></hr>
                                    <div className='element'>
                                        <div> <span>Cuisine Italienne</span></div>
                                        <div>  <span>Cuisine traditionnelle</span></div>
                                        <div>   <span>Cuisine exotique</span></div>
                                        <div> <span>Cuisine moléculaire</span></div>
                                        <div>  <span>Nouvelle cuisine</span></div>
                                    </div>
                                </div>
                                <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4'>
                                    <div className='titre_element'>
                                        <h3>Contacts</h3>
                                    </div>
                                    <hr />
                                    <div className='element'>
                                        <div className='bloc_element'>
                                            <img src={FACEBOOK} alt='logo facebook' className='logo_sociaux' />
                                            <span>e-kaly officiel</span>
                                        </div>
                                        <div className='bloc_element'>
                                            <img src={INSTA} alt='logo facebook' className='logo_sociaux' />
                                            <span>e-kaly officiel</span>
                                        </div>
                                        <div className='bloc_element'>
                                            <img src={LINKDIN} alt='logo facebook' className='logo_sociaux' />
                                            <span>e-kaly officiel</span>
                                        </div>
                                        <div className='bloc_element'>
                                            <img src={GMAIL} alt='logo facebook' className='logo_sociaux' />
                                            <span>e-kaly@gmail.com</span>
                                        </div>
                                        <div className='bloc_element'>
                                            <img src={PHONE} alt='logo facebook' className='logo_sociaux' />
                                            <span>0326859678</span> <span>-</span>
                                            <span> 0346859678</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </footer>
            <div className='legal'>
                <span>© Copyright 2022 I-kaly - TanaTeam</span>
            </div>
        </>
    )
}

export default Footer